/**
 * @file   src\Pages\AddSubscription.tsx
 * @brief  AddSubscription page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { useState, useRef, useEffect, Container, Button, Breadcrumb, Row, Col, useOutletContext, useNavigate, useParams, React, useLocation } from '../utils/thirdpartyComponents';
import "../styles/subscriptions.scss";
import CWSelect from '../components/CWSelect';
import CWInput from '../components/CWInput';
import CWCheckbox from '../components/CWCheckbox';
import CWInputGroup from '../components/CWInputGroup';
import { pageURLs } from '../utils/pageUrls';
import * as Yup from 'yup'
import { MessageToaster } from '../utils/toastUtil';
import { AMOUNT_MAX_LENGTH, WASH_DETAIL_MAX_LENGTH, WASH_NAME_MAX_LENGTH, WASH_NUMBER_MAX_LENGTH } from '../utils/constants';
import { AppContextType } from '../interfaces/generalInterface';
import CWMultiSelect from '../components/CWMultiSelect';
import axios from '../config/axiosConfig';
import { CompanyApi, LocationApi, SubscriptionApi } from '../utils/apiUrls';
import { LocationItem, Option, BulkSinglewashDataItem, SubscriptionItem } from '../interfaces/subscriptionInterface';
import GenerateLink from '../components/GenerateLink';
import CarWashStatus from '../components/CarWashStatus';
import CWTextarea from '../components/CWTextarea';
import SmallLoader from '../components/SmallLoader';
import { serviceType, userType } from '../utils/enums';
import { CommonMessages } from '../messages/validationMessages';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Essentials, Paragraph, Bold, Italic, Heading, LabelView } from 'ckeditor5';
import ClassicEditor from '../utils/classicEditor';
import { addBulkSingleWashSchema } from '../validations/addBulkSingleWashSchema';
import { forEachChild } from 'typescript';



const AddBulkSingleWash = (props: any) => {

    const carwash_owner = (props.userType === userType['CARWASH-OWNER']) ? true : false
    const edit = (props.edit === true) ? true: false;
    // State to handle locations given in dropdown
    const [locations, setLocations] = useState<Option[]>([]);
    const [companyDetails, setCompanyDetails] = useState<any>([]);
    const [editorKey, setEditorKey] = useState(0);
    
 

    const location = useLocation()
    const currentBayType = location?.state?.bayType
    console.log(currentBayType)



    // Use a ref to store input elements
    const formRef = useRef<HTMLFormElement>(null);

    // Initialize states for formdata

    const param = useParams();
    let subscription_type = "bulk"
    // param.type;
    if (subscription_type !== 'day' && subscription_type !== 'month') {
        subscription_type = 'bulk'
    }

    const [formData, setFormData] = useState<BulkSinglewashDataItem>({
        location: [],
        washname: '',
        washdetails: '',
        washnumber: '0',
        washTime:'0',
        amount: '',
        hasVacuumWash: false,
        numberOfVacuumWashes: '0',
        maxVacuumTime: '0',

    })
    // Initialise states for errors
    const [errors, setErrors] = useState({
        location: '',
        washname: '',
        washdetails: '',
        washnumber: '',
        maxwashperday: '',
        amount: '',
        trialAmount: '',
        trialPeriod: '',
        hasVacuumWash: '',
        numberOfVacuumWashes: '',
        maxVacuumTime: '',
        category: '',
    });

    // State to handle selected location
    const [selectedLocation, setSelectedLocation] = useState<Option[]>([]);
    const [categoryOptions, setCategoryOptions] = useState<Option[]>([]);
    const [showCategory, setShowCategory] = useState(false);
    const [category, setCategory] = useState<number | ''>('');
    const categoryVisibilityRequest = useRef(0);

    // State to company details
    const [company, setCompany] = useState({
        companyName: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipCode: ""
    });

    const [loading, setLoading] = useState(true);

    // Access the context
    const { updateData } = useOutletContext<AppContextType>();

    const navigate = useNavigate()

    const toaster = new MessageToaster();

    useEffect(() => {
        getCompany()
        getCompanyAddress();
        getCategories();
        if(edit)
        {
            getBulkWashDetails()
        }
    }, [])


    useEffect(() => {
        // To display heading
        handleUpdate()
    }, [company])

    // Update the data
    const handleUpdate = () => {
        updateData({ heading: carwash_owner ? props.edit? 'Edit Prepaid Discount Package' : 'Add Prepaid Discount Package' : company.companyName, url: carwash_owner ? `/${pageURLs.manage_subscriptions}?type=${subscription_type}&bayType=${currentBayType}` : `/superadmin/${pageURLs.manage_subscriptions}/${param.id}`, showBackButton: true, showMainMenu: true, activeLink: carwash_owner ? "manage-subscriptions" : "manage-car-wash" });
    };


  

    // Function to fetch company information
    const getCompany = async () => {
        try {
            const param1 = `${param.id}`;
            const { data } = (!carwash_owner) ?
                await axios.get(CompanyApi.GET_COMPANY + param1) :
                await axios.get(CompanyApi.CARWASH_OWNER_COMPANY_DETAILS);

            // To get locations under company
            await getCompanyLocations(data.data.carWashGUID)
            setCompanyDetails(data.data)

        } catch (error: any) {
            console.error('Error fetching company information:', error.message);
            throw new Error(error.response?.data?.message || error.message);
        }
    };


    // To get company details
    const getCompanyAddress = async () => {
        try {
            const id = param.id ? parseInt(param.id) : 0;
            const { data } = (!carwash_owner) ?
                await axios.get(CompanyApi.GET_COMPANY_ADDRESS + id) :
                await axios.get(CompanyApi.CARWASH_OWNER_COMPANY_ADDRESS)
            if (data?.error === 0) {
                setCompany(data.data);
            }
            setLoading(false)
        } catch (error: any) {
            throw new Error(error.response?.data?.message || error.message);
        }
    }

    const getCompanyLocations = async (carwashGuid: string) => {
        try {

            const { data } = (!carwash_owner) ?
                await axios.get(LocationApi.GET_COMPANY_LOCATIONS + carwashGuid)
                : await axios.get(LocationApi.CARWASH_OWNER_GET_COMPANY_LOCATIONS);
            if (data.error === 0) {
                const location_list: LocationItem[] = data?.data

                // Transform the array
                const transformedArray: Option[] = location_list.map(item => ({
                    label: item.locationName,
                    value: item.locationId,
                }));

                setLocations(transformedArray)
            }
            else {
                // show error message
                toaster.toastError(data.message);
            }
        } catch (error: any) {
            throw new Error(error.response?.data?.message || error.message);
        }
    }

    const getCategories = async () => {
        try {
            const { data } = await axios.get(
                !carwash_owner
                    ? LocationApi.ADMIN_GET_CATEGORIES
                    : LocationApi.GET_CATEGORIES
            );
            if (data.error === 0) {
                const categoryList = Array.isArray(data?.data) ? data.data : [];
                const transformedArray: Option[] = categoryList
                    .map((item: any) => ({
                        label: item.washCategoryName ?? '',
                        value: item.washCategoryId ?? 0,
                    }))
                    .filter((item: Option) => item.label && item.value !== undefined && item.value !== null);

                // if (transformedArray.length > 0) {
                //     const hasBoth = transformedArray.some(
                //         (item) => String(item.label).toLowerCase() === 'both'
                //     );
                //     if (!hasBoth) {
                //         transformedArray.push({ label: 'Both', value: 0 });
                //     }
                // }

                setCategoryOptions(transformedArray);
            } else {
                toaster.toastError(data.message);
            }
        } catch (error: any) {
            console.error('Error fetching categories:', error.message);
        }
    }

    const isComboWashLocation = (locationDetails: any) => {
        const comboWash = locationDetails?.comboWash
            ?? locationDetails?.ComboWash
            ?? locationDetails?.isComboWash
            ?? locationDetails?.IsComboWash;

        return comboWash === 1 || comboWash === true || comboWash === "1";
    }

    const resetCategory = () => {
        setCategory('');
        setErrors((prevErrors) => ({
            ...prevErrors,
            category: ''
        }));
    }

    const updateCategoryVisibility = async (selectedOptions: Option[], savedCategoryId?: number | '' | null) => {
        const requestId = categoryVisibilityRequest.current + 1;
        categoryVisibilityRequest.current = requestId;
        const selectedLocations = selectedOptions || [];
        const hasSavedCategory = savedCategoryId !== undefined && savedCategoryId !== null && savedCategoryId !== '';

        if (!selectedLocations.length) {
            if (edit && hasSavedCategory) {
                setShowCategory(true);
                return;
            }
            setShowCategory(false);
            resetCategory();
            return;
        }

        try {
            const locationDetails = await Promise.all(
                selectedLocations.map((location) => {
                    const locationDetailsUrl = (!carwash_owner)
                        ? LocationApi.GET_SINGLE_LOCATION
                        : LocationApi.CARWASH_OWNER_LOCATION_DETAILS;

                    return axios.get(locationDetailsUrl + location.value);
                })
            );

            if (requestId !== categoryVisibilityRequest.current) {
                return;
            }

            const hasComboWashLocation = locationDetails.some(({ data }) => isComboWashLocation(data?.data));
            setShowCategory(hasComboWashLocation || (edit && hasSavedCategory));

            if (!hasComboWashLocation && !(edit && hasSavedCategory)) {
                resetCategory();
            }
        } catch (error: any) {
            if (requestId !== categoryVisibilityRequest.current) {
                return;
            }

            if (edit && hasSavedCategory) {
                setShowCategory(true);
                return;
            }
            setShowCategory(false);
            resetCategory();
        }
    }

    const handleCategoryChange = (selectedOption: any) => {
        const value = selectedOption ? selectedOption.value : '';

        setErrors({
            ...errors,
            category: ""
        });
        setCategory(value);
    }

       const getBulkWashDetails = async () => {
           try {
               const { data } = (!carwash_owner) ?
                   await axios.get(SubscriptionApi.GET_SUBSCRIPTION_DETAILS + param.id)
                   :
                   await axios.get(SubscriptionApi.CARWASH_OWNER_GET_SUBSCRIPTION_DETAILS + param.id)
               if (data.error === 0) {
                    console.log(data.data)
                    const subscription: SubscriptionItem = data.data[0]
                   const transformedLocationArray: Option[] =
                       subscription.Locations.map(item => ({
                           value: item.LocationID,
                           label: item.LocationName
                       }))
                   const subscriptionCategoryId = subscription.WashCategoryID ?? (subscription as any).washCategoryId ?? (subscription as any).washCategory ?? (subscription as any).categoryId ?? (subscription as any).CategoryID ?? (subscription as any).CategoryId ?? (subscription as any).category_id;
                   const savedCategory = subscriptionCategoryId !== undefined && subscriptionCategoryId !== null && subscriptionCategoryId !== ''
                       ? Number(subscriptionCategoryId)
                       : '';
                   setCategory(savedCategory);
                   if (savedCategory !== '') {
                       setShowCategory(true);
                   }
                   setSelectedLocation(transformedLocationArray);
                   updateCategoryVisibility(transformedLocationArray, savedCategory);
                       
                   const subscriptionData: BulkSinglewashDataItem = {
                       location: transformedLocationArray,
                       washname: subscription.WashName,
                       washdetails: subscription.SubscriptionDetails,
                       washnumber: subscription?.NumberOfWashes?.toString() || '0',
                       washTime:subscription?.WashTime?.toString() || '0',
                       amount: subscription?.Price?.toString() || '0',
                       hasVacuumWash: (subscription?.hasVacuumWash === 1) ? true : false,
                       numberOfVacuumWashes:subscription?.numberOfVacuumWashes?.toString() || '0',
                       maxVacuumTime: subscription?.maxVacuumTime?.toString() || '0',
                   }
                //    setSelectedLocation(subscriptionData.location || [])
                   console.log(subscriptionData)
                   setFormData(subscriptionData)
                    setEditorKey(prevKey => prevKey + 1);
               }
               else {
                   // show error message
                   toaster.toastError(data.message);
               }
           } catch (error: any) {
               console.error('Error fetching company information:', error.message);
               // throw new Error(error.response?.data?.message || error.message);
           }
       }
   



    const handleMultiSelectChange = (selectedOption: Option[], name: string) => {
        setSelectedLocation(selectedOption)
        updateCategoryVisibility(selectedOption);
        // To remove validation when user enters input
        const keys = Object.keys(errors);
        if (keys.includes(name)) {
            setErrors({
                ...errors,
                [name]: ""
            })
        }

        setFormData({
            ...formData,
            [name]: selectedOption,
        });

    }

    // Triggers whenever input is entered
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        const { name, value } = event.target

        // To remove validation when user enters input
        const keys = Object.keys(errors);
        if (keys.includes(name)) {
            setErrors({
                ...errors,
                [name]: ""
            })
        }

        if (name === 'amount') {
            // Regex to match the input value with up to 2 decimal places
            const regex = /^\d{0,8}(\.\d{0,2})?$/;

            if (regex.test(value)) {
                setFormData({
                    ...formData,
                    [name]: value,
                });
            }
        } 
    
        else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    }


    // Triggers on submit
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {

        event.preventDefault()
        try {
            console.log(formData)
           
            

            await addBulkSingleWashSchema.validate(formData, { abortEarly: false });
            if (showCategory && (category === '' || category === null || category === undefined)) {
                setErrors({
                    ...errors,
                    category: "Select Category."
                });
                return false;
            }
         

            const locationIdArray = formData.location && formData.location.map(loc => loc.value)

            const newformData = (!carwash_owner) ? {
                carWashId: param.id ? parseInt(param.id) : 0,
                locationIds: locationIdArray,
                washName: formData.washname,
                subscriptionDetails: formData.washdetails,
                numberOfWashes: Number(formData.washnumber),
                price: parseFloat(formData.amount),
                washTime:Number(formData.washTime),
                bayType:currentBayType,
                hasVacuumWash: formData.hasVacuumWash ?? 0,
                numberOfVacuumWashes: Number(formData.numberOfVacuumWashes ?? 0),
                maxVacuumTime: Number(formData.maxVacuumTime ?? 0),
                washCategoryId: showCategory ? Number(category) : null,

            } : {
                locationIds: locationIdArray,
                washName: formData.washname,
                subscriptionDetails: formData.washdetails,
                numberOfWashes: Number(formData.washnumber),
                washTime: Number(formData.washTime),
                price: parseFloat(formData.amount),
                bayType:currentBayType,
                hasVacuumWash: formData.hasVacuumWash ,
                numberOfVacuumWashes: Number(formData.numberOfVacuumWashes ?? 0),
                maxVacuumTime: Number(formData.maxVacuumTime ?? 0),
                washCategoryId: showCategory ? Number(category) : null,
            }

            try {
                setLoading(true)
                console.log(newformData)
                let data;

                if (props.edit) {
                    // Build edit payload (without locationIds)
        const { locationIds, ...editRequest } = newformData;

        // editPayload.subscriptionId = param.subscriptionId;
                    const editPayload = {
                        ...editRequest,
                        subscriptionId: parseInt(param.id || ''),  
                    };
                    ({ data } = !carwash_owner
                        ? await axios.post(SubscriptionApi.EDIT_BULK_SINGLE_WASH, editPayload)
                        : await axios.post(SubscriptionApi.CARWASH_OWNER_EDIT_BULK_SINGLE_WASH, editPayload)
                    );
                } else {
                    ({ data } = !carwash_owner
                        ? await axios.post(SubscriptionApi.ADD_BULK_SINGLE_WASH, newformData)
                        : await axios.post(SubscriptionApi.CARWASH_OWNER_ADD_BULK_SINGLE_WASH, newformData)
                    );
                }

                setLoading(false);

                if (data?.error === 0) {
                    //Clear errors
                    setErrors({
                        location: '',
                        // subscription: '',
                        washname: '',
                        washdetails: '',
                        washnumber: '',
                        maxwashperday: '',
                        amount: '',
                        trialAmount: '',
                        trialPeriod: '',
                        hasVacuumWash: '',
                        numberOfVacuumWashes: '',
                        maxVacuumTime: '',
                        category: '',
    
                    });
                    const subscriptionId = data.data.subscriptionId[0]
                    if(props.edit)
                    {

                    if (!carwash_owner) {
                                            const redirectUrl = `/superadmin/${pageURLs.manage_subscriptions}/${param.carWashId}`
                                            navigate(redirectUrl)
                                        } else {
                                            const redirectUrl =  `/${pageURLs.manage_subscriptions}?bayType=${currentBayType}&type=bulk`
                                            navigate(redirectUrl)
                                        }

                    }
                    else{
                        if(currentBayType==serviceType.Inbay)
                        {
                             if (!carwash_owner) {
                        navigate(`/superadmin/${pageURLs.add_relaynumber}/${param.id}/${subscriptionId}`, {state: { type: "bulk" }})
                            } else {
                                navigate(`/${pageURLs.add_relaynumber}/${subscriptionId}`, {state: { type: "bulk" }})
                            }
                            
                        }
                        else{
                             if (!carwash_owner) {
                                            const redirectUrl = `/superadmin/${pageURLs.manage_subscriptions}/${param.carWashId}`
                                            navigate(redirectUrl)
                                        } else {
                                            const redirectUrl =  `/${pageURLs.manage_subscriptions}?bayType=${currentBayType}&type=bulk`
                                            navigate(redirectUrl)
                                        }
                        }
                   
                    }
                }
                else {
                    // show error message
                    toaster.toastError(data?.message);
                }
            } catch (error: any) {
                throw new Error(error?.response?.data?.message || error?.message);
            }


        } catch (error) {
            const newErrors: any = {};

            // If validation fails on submit, then errors are shown
            if (error instanceof Yup.ValidationError) {
                error.inner.forEach((err) => {
                    newErrors[err.path as keyof typeof formData] = err.message;
                });
                console.log(newErrors)
                setErrors(newErrors);
            }

            // Focus on the first invalid field
            if (formRef.current) {
                const firstInvalidField = Object.keys(newErrors)[0];
                const invalidElement = formRef.current.querySelector<HTMLInputElement>(`[name="${firstInvalidField}"]`);
                if (invalidElement) {
                    invalidElement.focus();
                }
            }
        }

    }

    // Navigate accordung to url
    const itemClick = async (url: string) => {
        navigate(url);
    }




     const setFreeVacuumData = async (e: any) => {
        if (e.target.name === 'hasVacuumWash') {
            if (e.target.checked === true) {
        
                    setFormData({
                    ...formData,
                    [e.target.name]: e.target.checked,
                });
                
            } else {
                setFormData({
                    ...formData,
                    [e.target.name]: e.target.checked,
                    ['hasVacuumWash']: false,
                    ['numberOfVacuumWashes']: '0',
                    ['maxVacuumTime']: '0',
                });
            }
        } 
    }
const setUnLimitedData = async (e: any) => {
    if (e.target.checked === true) {
         setFormData({
            ...formData,
            [e.target.name]: e.target.checked,
            ['washnumber']:'0'
        });
     }
     else{
         setFormData({
            ...formData,
            [e.target.name]: e.target.checked,
        });
     }
}


    return (

        <div className='manage-carwash-container manage-subscription-container'>
            <Container>
                <Breadcrumb>
                    {carwash_owner ? null :
                        <>
                            <Breadcrumb.Item onClick={() => { itemClick(`/superadmin/${pageURLs.manage_carwash}`) }}>Manage Car Washes</Breadcrumb.Item>
                            <Breadcrumb.Item onClick={() => { itemClick(`/superadmin/${pageURLs.carwash_locations}/${param.id}`) }}  >{company.companyName}</Breadcrumb.Item>
                        </>
                    }

                    <Breadcrumb.Item
                        onClick={() => {
                            const url = carwash_owner
                                ? `/${pageURLs.manage_subscriptions}?type=${subscription_type}`
                                : `/superadmin/${pageURLs.manage_subscriptions}/${param.id}`;
                            itemClick(url);
                        }}
                    >
                        {subscription_type === 'bulk' ? 'Manage Prepaid Discount Packages' : subscription_type === 'day' ? 'Manage Single Wash' : 'Manage Subscriptions'}
                    </Breadcrumb.Item>

                    <Breadcrumb.Item active>{props.edit? 'Edit Prepaid Discount Package' : 'Add Prepaid Discount Package'}</Breadcrumb.Item>
                </Breadcrumb>
                {carwash_owner ? null :
                    <div className="manage-activity-wrap d-flex justify-content-between align-items-center">
                        {companyDetails && <GenerateLink id={param.id} companyDetails={companyDetails} carwash_owner={carwash_owner} />}
                        <div className="activity-status d-flex">


                            <CarWashStatus carWashId={param.id} status={(companyDetails?.IsCompanyActive == 1) ? true : false} companyName={company.companyName} />


                        </div>
                    </div>}

                <div className='cw-form-outer-wrap'>
                    <form onSubmit={(e) => handleSubmit(e)} ref={formRef}>
                        <div className="cw-form-container">
                            <div className="form-inner mx-auto">

                                <div>
                                    <CWMultiSelect
                                        id="location"
                                        name="location"
                                        options={locations}
                                        label="Select Location"
                                        dropdownGap={0}
                                        dropdownPosition="auto"
                                        isMandatory
                                        placeholder="Select Location"
                                        errorMessage={errors.location}
                                        onChange={(selectedOptions) => handleMultiSelectChange(selectedOptions, "location")}
                                        hasSelectAll={true}
                                        value={formData.location || selectedLocation}
                                        disabled={props.edit}
                                        labelAllSelected="All Locations Selected."
                                    />
                                    {showCategory ? (
                                        <div className="mt-4">
                                            <CWSelect
                                                id="category"
                                                name="category"
                                                options={categoryOptions}
                                                label="Category"
                                                errorMessage={errors.category && errors.category}
                                                dropdownGap={0}
                                                dropdownPosition="auto"
                                                values={categoryOptions.filter(
                                                    (option) =>
                                                        category !== '' &&
                                                        option.value === Number(category)
                                                )}
                                                onChange={(selectedOptions) =>
                                                    handleCategoryChange(selectedOptions[0])
                                                }
                                                placeholder="Select Category"
                                                multi={false}
                                                searchable={false}
                                                isMandatory
                                            />
                                        </div>
                                    ) : null}
                                    
                                </div>
                 
                                <Row>
                                      
                                   <Col md={6}>
                                   <CWInput
                                            id="washname"
                                            name="washname"
                                            type="text"
                                            label="Wash Name"
                                            maxLength={WASH_NAME_MAX_LENGTH}
                                            isMandatory
                                            value={formData.washname}
                                            errorMessage={errors.washname}
                                            onChange={handleInputChange}
                                        />

                                    </Col>
                                    <Col md={6}>
                                    <div className="form-group cw-input">
                                    <div className="cust-label-group">
                                        <label htmlFor="label">Wash details
                                            <span className="mandatory">*</span>

                                        </label>
                                    <div key={editorKey} >
                                         <CKEditor
                                                                            editor={ClassicEditor as any}
                                                                            config={{
                                                                                licenseKey: 'GPL',
                                                                                plugins: [Essentials, Paragraph, Bold, Italic, Heading],
                                                                                toolbar: [
                                                                                    'heading', '|', 'bold', 'italic', 'underline', 'strikethrough', '|',
                                                                                    'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
                                                                                    'undo', 'redo', '|', 'alignment', 'fontSize', 'fontColor',
                                                                                    'fontBackgroundColor', 'highlight', 'codeBlock',
                                                                                    'insertTable', 'imageUpload', 'mediaEmbed'
                                                                                ],
                                                                                heading: {
                                                                                    options: [
                                                                                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                                                                                        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                                                                                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                                                                                        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                                                                                        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' }
                                                                                    ]
                                                                                },
                                                                                image: {
                                                                                    toolbar: [
                                                                                        'imageTextAlternative', 'toggleImageCaption',
                                                                                        'imageStyle:full', 'imageStyle:side'
                                                                                    ]
                                                                                },
                                                                                table: {
                                                                                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
                                                                                },
                                                                            }}
                                                                              onReady={(editor) => {
                                                                                if (formData.washdetails) {
                                                                                    editor.setData(formData.washdetails);
                                                                                }
                                    
                                                                            }}
                                                                            onChange={(event, editor) => {
                                                                                const data = editor.getData();
                                                                                setFormData((prev) => ({
                                                                                    ...prev,
                                                                                    washdetails: data,
                                                                                }));
                                                                                setErrors({
                                                                                ...errors,
                                                                                ['washdetails']: ""
                                                                            })
                                    
                                                                            }}
                                                                    
                                                                        />
                                                                        <span className='error-msg'>{errors.washdetails}</span>
                                                                        </div>
                                                                        </div>
                                                                        </div>
                                    </Col>
                                    </Row>
                                    <Row>
                                    
                                     <Col md={6}>
                                        <div className="custom-note position-relative">
                                            {currentBayType === serviceType.Inbay ? <CWInput
                                                id="washnumber"
                                                name="washnumber"
                                                type="number"
                                                label="Count"
                                                maxLength={WASH_NUMBER_MAX_LENGTH}
                                                isMandatory
                                                value={ formData.washnumber}
                                                errorMessage={errors.washnumber}
                                                onChange={handleInputChange}
                                                // readOnly={formData.subscription === "day" }
                                            /> :
                                             <CWInput
                                                id="washTime"
                                                name="washTime"
                                                type="number"
                                                label="Select Time (Minutes)"
                                                maxLength={WASH_NUMBER_MAX_LENGTH}
                                                isMandatory
                                                value={formData.washTime}
                                                // errorMessage={errors.washTime  && currentBayType==serviceType.Vacuum ? "Enter valid vacuum time.":errors.washTime}
                                                onChange={handleInputChange}
                                                // readOnly={formData.subscription === "day"}
                                            />}
                                            {/* <span className="note"><i>*Single Wash value will be set to 1 by default</i></span> */}
                                        </div>
                                     </Col>
                                    
                                </Row>
                                <Row>
                         

                                   

                                    <Col md={6}>
                                        <CWInputGroup
                                            id="amount"
                                            name="amount"
                                            type="number"
                                            step='0.01'
                                            label="Amount"
                                            labelPrefix="$"
                                            isMandatory
                                            maxLength={AMOUNT_MAX_LENGTH}
                                            value={formData.amount}
                                            errorMessage={errors.amount}
                                            onChange={handleInputChange}
                                        />
                                        
                                    </Col>
                                    
                                </Row>
                             
                         
                                    
                                
{/* free vacuum wash */}
<div className="trial-sec mt-4">
{
    currentBayType!=serviceType.Vacuum ?

                                    <CWCheckbox
                                        id="hasVacuumWash"
                                        name="hasVacuumWash"
                                        label="Offer Free Vacuum / Mat Washer"
                                        checked={formData.hasVacuumWash}
                                        onChange={(e) => { setFreeVacuumData(e); }}
                                    />
                                    :""}

                                    {formData.hasVacuumWash ? <Row>
                                        <Col md={6}>
                                            <CWInput
                                                id="numberOfVacuumWashes"
                                                name="numberOfVacuumWashes"
                                                label="Number of Times"
                                                 maxLength={WASH_NUMBER_MAX_LENGTH}
                                                isMandatory
                                                value={formData.numberOfVacuumWashes}
                                                errorMessage={errors.numberOfVacuumWashes}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                        <Col md={6}>
                                                <CWInput
                                                id="maxVacuumTime"
                                                name="maxVacuumTime"
                                                label="Maximum Time per Use (in minutes)"
                                                 maxLength={WASH_NUMBER_MAX_LENGTH}
                                                isMandatory
                                                value={formData.maxVacuumTime}
                                                errorMessage={errors.maxVacuumTime}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </Row> : ''}
                                    
                                </div> 



                            </div>
                        </div>
                        <div className="btn-sec d-flex justify-content-end">
                            <Button title="Cancel" variant="primary" className="secondary-btn" onClick={() => {
                                const url = carwash_owner
                                    ? `/${pageURLs.manage_subscriptions}`
                                    : `/superadmin/${pageURLs.manage_subscriptions}/${param.id}`;
                                navigate(url);
                            }}>Cancel
                            </Button>
                            <Button title="Next" variant="primary" className="primary-btn" type="submit">{currentBayType==serviceType.Inbay && !props.edit ? "Next":"Save"}</Button>
                        </div>
                    </form>
                </div>
            </Container>
            {loading && <SmallLoader />}

        </div >
    )
}


export default AddBulkSingleWash;
